import { render, staticRenderFns } from "./disciplinesTable.vue?vue&type=template&id=3f8a190c&scoped=true"
import script from "./disciplinesTable.vue?vue&type=script&lang=js"
export * from "./disciplinesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a190c",
  null
  
)

export default component.exports